import { observer } from 'mobx-react-lite'
import { Tooltip } from 'shared/ui'
import { type ISwitchActionProps, SwitchAction } from 'shared/ui/SwitchAction'
import { ChatbotStatus } from 'entities/Chatbot'

type Props = {
  item: { id: number; status: ChatbotStatus }
  onToggle: () => Promise<void>
  size?: ISwitchActionProps['size']
  className?: string
}

export const TextingActiveToggle = observer(
  ({ item, onToggle, size = 'small', className }: Props) => {
    const isInvalid = item.status === ChatbotStatus.Invalid
    const isDraft = item.status === ChatbotStatus.Draft

    const tooltipLabel = isInvalid
      ? 'Suspicious content detected'
      : isDraft
      ? 'Complete required info to enable'
      : undefined

    return (
      <div className={className}>
        <Tooltip label={tooltipLabel} placement={'top'}>
          <SwitchAction
            size={size}
            active={item.status === ChatbotStatus.Active}
            disabled={isInvalid || isDraft}
            onTrigger={onToggle}
            ariaLabel={`TextingActiveToggle-${item.id}`}
          />
        </Tooltip>
      </div>
    )
  }
)
